import type { AuthType } from '@contexts/auth-provider/AuthProvider.types';

/**
 * Determines the required auth type for a given URL path.
 *
 * Strict module routes:
 * - `/train/*` → B2C (external customers/trainees)
 * - `/instruct/*` → B2E (internal CAE employees)
 *
 * Returns null for paths that accept both auth types (e.g., `/manage`, `/home`).
 *
 * @param path - The URL path to check
 * @returns The required auth type, or null if no strict requirement
 */
export function getRequiredAuthType(path: string): AuthType | null {
  if (path.startsWith('/train')) return 'b2c';
  if (path.startsWith('/instruct')) return 'b2e';
  if (path.startsWith('/login/internal')) return 'b2e';
  if (path.startsWith('/manage/sf-redirect')) return 'b2e';
  return null;
}
